import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function topMedia01() {
  const images = document.querySelectorAll(".c-media01__image");
  if (!images.length) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) return;

  const init = () => {
    images.forEach((image) => {
      ScrollTrigger.create({
        trigger: image,
        start: "top 90%",
        once: true,
        onEnter: () => {
          gsap.fromTo(
            image,
            {
              scale: 0,
              autoAlpha: 0,
              transformOrigin: "center center",
            },
            {
              scale: 1,
              autoAlpha: 1,
              duration: 0.7,
              ease: "back.out(1.6)",
            }
          );
        },
      });
    });

    ScrollTrigger.refresh();
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
}
